import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { environment } from '../../environments/environment';
import { take } from 'rxjs/operators';
import { AuthGuard, AuthService } from '@auth0/auth0-angular';
import { OrganizationManager } from '../managers/organization.manager';
import { LoggingService } from '../../../../modules/src/lib/core/services/logging.service';
import { Injectable } from '@angular/core';
import { InviteManager } from '../managers/invite.manager';

@Injectable()
export class OnlyLoginGuard implements CanActivate {
  private hasFullyLoggedIn = false;

  constructor(
    protected authGuard: AuthGuard,
    protected authService: AuthService,
    protected router: Router,
    protected organizationManager: OrganizationManager,
    protected inviteManager: InviteManager,
    protected loggingService: LoggingService,
  ) {
  }

  fullyLoginAtLeastOnce(): Promise<void> {
    return new Promise(resolve => {
      if (this.hasFullyLoggedIn) {
        return resolve();
      }

      this.authService.getAccessTokenSilently({
        authorizationParams: {
          audience: environment.auth0Audience,
          scope: 'openid profile email read:all',
        },

      }).pipe(take(1)).subscribe(value => {
        this.hasFullyLoggedIn = true;
        return resolve();
      }, error => {
        this.authService.getAccessTokenWithPopup({
          authorizationParams: {
            audience: environment.auth0Audience,
            scope: 'openid profile email read:all',
          },
        }).subscribe(value => {
          this.hasFullyLoggedIn = true;

          return resolve();
        }, error => {
          this.loggingService.error(error);
          return resolve();
        });
      });
    });
  }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    return new Promise((resolve, reject) => {
      // If you are not logged-in, redirect to login
      this.authGuard.canActivate(route, state).subscribe(async isAuthenticated => {
        if (isAuthenticated === false) {
          this.loggingService.debug('[Guard:\'access\'] - User is not authenticated, the guard will be redirecting the users to the login portal.');
          return resolve(false);
        }

        // todo: try to see if we can do this in parallel. I think we can.
        this.fullyLoginAtLeastOnce().then(r => {
          this.loggingService.debug('Login silently completed');
        });

        // Preload invites
        this.inviteManager.getForCurrentUser().then(value => {
          this.loggingService.debug('Invites preloaded');
        });

        // Else, you have access
        return resolve(true);
      });
    });
  }
}
